<template>
  <section>
    <div v-if="loading && authenticated">
      <b-overlay :show="loading" rounded="sm" opacity="0.5">
        <h4 class="m-0 p-0 mb-3">
          <b-skeleton-img no-aspect height="30px" width="20%"></b-skeleton-img>
        </h4>

        <b-skeleton
          type="button"
          size="sm"
          class="closeBtn mt-4 mr-4"
        ></b-skeleton>

        <b-skeleton type="avatar"></b-skeleton>

        <hr class="pb-0 mb-0 mt-2" />

        <div class="mt-2">
          <b-skeleton-img no-aspect height="56px" width="20%"></b-skeleton-img>
        </div>

        <div class="mt-2">
          <b-skeleton></b-skeleton>
        </div>

        <hr class="pb-0 mb-0 mt-2" />
        <b-skeleton-img no-aspect height="30px" width="20%"></b-skeleton-img>
      </b-overlay>
    </div>
    <div v-if="!loading">
      <div v-if="information.auth_message == 'open_to_date'" class="mt-4 mb-4">
        {{ $t("SECURELINK.TEAMS.EXPIRED") }}
      </div>
      <div
        v-if="information.auth_message == 'open_from_date'"
        class="mt-4 mb-4"
      >
        {{ $t("SECURELINK.TEAMS.LOCKED") }}
        {{
          FormatDateTime(information.open_from_date)
        }}
      </div>

      <div v-if="information.message">
        <h4 class="m-0 p-0 mt-2 mb-3  link-header">
          {{ information.message.subject }}
        </h4>

        <h4 class="m-0 p-0 mt-2 mb-1  link-header">
          {{ $t("ORGANISER") }}
        </h4>
        
        
        <UserInfo
          image="/img/default-avatar.png"
          :primary="createdName"
          :secondary="information.message.creator.email"
          :optional="createdTime"
        ></UserInfo>

        <hr class="pb-0 mb-0 mt-2" />

        <div class="d-flex">
          <div style="width: 12rem;" class="ml-0 pl-0">
            <h4 class="m-0 p-0 mt-2 mb-1  link-header">{{ $t("FROM") }}</h4>
            {{
              FormatDateTime(information.message.settings.open_from_date)
            }}
          </div>
          <div style="width: 12rem;" class="ml-0 pl-0">
            <h4 class="m-0 p-0 mt-2 mb-1  link-header">{{ $t("TO") }}</h4>
            {{
              FormatDateTime(information.message.settings.open_to_date)
            }}
          </div>
        </div>

        <hr class="pb-0 mb-0 mt-2" />

        <div v-if="information.auth_message == 'open_to_date'">
          <div  class="mt-4 mb-4"
        >
            {{ $t("SECURELINK.JITSI.EXPIRED") }}
          </div>
        </div>
        <div
          v-if="information.auth_message == 'open_from_date'"
          class="mt-4 mb-4"
        >
          {{ $t("SECURELINK.JITSI.LOCKED") }}
          {{
            FormatDateTime(information.open_from_date)
          }}
        </div>
        <div
          v-if="
            information.auth_message != 'open_to_date' &&
              information.auth_message != 'open_from_date'
          "
        >
          <div class="mt-2" v-if="attachments.length != 0">
            <span
              v-for="(item, index) in attachments"
              :key="index"
              class="ms-fontSize-12"
            >
              <Attachment :link_uuid="link_uuid" :item="item" :index="index"></Attachment>
            </span>
          </div>

          <h4 class="m-0 p-0 mt-2 mb-1  link-header">
            {{ $t("DESCRIPTION") }}
          </h4>

          <BodyText :body="information.external_text"></BodyText>

          <hr class="pb-0 mb-2 mt-2" />

          <a :href="join_url" class="btn btn-fill btn-primary text-white">{{
            $t("SECURELINK.TEAMS.JOIN_MEETING")
          }}</a>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import UserInfo from "@/components/Layout/UserInfo";
import Attachment from "@/components/View/Attachment";
import BodyText from "@/components/View/BodyText";
export default {
  components: {
    UserInfo,
    Attachment,
    BodyText,
  },
  props: ["link_uuid", "open_time", "loading", "information", "authenticated"],
  data() {
    return {};
  },
  methods: {
    closeBtn() {
      this.$emit("closeBtn");
    },
  },
  computed: {
    attachments() {
      return this.information.message.attachments.filter((attachment) => {
        return attachment.name != "join_url.txt";
      });
    },
    join_url() {
      let join_attachment = this.information.message.attachments.filter(
        (attachment) => {
          return attachment.name == "join_url.txt";
        }
      );
      if (join_attachment.length == 1) {
        return join_attachment[0].content;
      } else {
        return null;
      }
    },
    createdTime() {
      return this.FormatDateTime(this.information.message.created_date);
    },
    createdName() {
      return (
        this.information.message.creator.name +
        ", " +
        this.information.message.creator.organisation_name
      );
    },
  },
  mounted: function() {},
};
</script>
<style></style>
